import { FC, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import linkedinImg from "../../assets/media/linkedin.svg";
import { toPng } from "html-to-image";

type Props = {
  licenseCode: string;
  isOpen?: boolean;
};

const POST_TEXT =
  "I recently mapped my Leadership Fingerprint™.\nThese are the values that drive how I lead and make decisions.\nWhat are yours?";

export const ShareToLinkedIn: FC<Props> = ({ licenseCode, isOpen }) => {
  const [showLinkedInModal, setShowLinkedInModal] = useState(false);
  const [img, setImg] = useState<string>("");

  // Use fixed redirect URI - LinkedIn doesn't support dynamic paths
  const redirectUri = `${process.env.REACT_APP_EXPERIENCE_BASE_URL}/linkedin-callback`;

  const getImg = async (el: HTMLElement | null) => {
    if (el) {
      const src = await toPng(el, { pixelRatio: 1 });
      setImg(src);
    }
  };

  useEffect(() => {
    getImg(document.getElementById("linkedin-share-card"));
  });

  const handleShareClick = () => {
    if (img) {
      sessionStorage.setItem("linkedin-share-image", img);
    }
    sessionStorage.setItem("linkedin-post-text", POST_TEXT);
    sessionStorage.setItem("linkedin-return-url", window.location.pathname);
  };

  return (
    <>
      <Button
        onClick={() => setShowLinkedInModal(true)}
        className="btn-white no-wrap"
        style={{ marginTop: 20 }}
      >
        Share to LinkedIn <img style={{ width: 50 }} src={linkedinImg} alt="" />
      </Button>

      <Modal
        centered
        show={showLinkedInModal || isOpen}
        onHide={() => setShowLinkedInModal(false)}
      >
        <Modal.Title>
          This is what your shared content will look like:
        </Modal.Title>

        <Modal.Body style={{ padding: 0 }}>
          <div style={{ padding: "16px 16px 0" }}>
            <div style={{ fontSize: 16, marginBottom: 12, whiteSpace: "pre-line" }}>{POST_TEXT}</div>
          </div>

          <img src={img} alt="" style={{ width: "100%", display: "block" }} />
        </Modal.Body>

        <Modal.Footer>
          <div
            style={{
              display: "flex",
              gap: 10,
            }}
          >
            <a
              href={`https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${
                process.env.REACT_APP_LINKEDIN_CLIENT_ID
              }&state=${licenseCode}&scope=w_member_social%20openid%20profile%20email&redirect_uri=${encodeURIComponent(
                redirectUri,
              )}`}
              onClick={handleShareClick}
              className="btn-primary no-wrap"
            >
              Share <img style={{ width: 50 }} src={linkedinImg} alt="" />
            </a>
          </div>

          {/* <input type="file" id="file" /> */}
        </Modal.Footer>
      </Modal>
    </>
  );
};
